export default __webpack_public_path__ + "static/media/NotoSans-BoldItalic.406a212c.ttf";